import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modalConfirmStatusComment",
  style: {"z-index":"1600"},
  tabindex: "-1",
  "aria-labelledby": "modalConfirmStatusComment",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title w-100 text-center fw-bold" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "text-center my-3" }
const _hoisted_8 = { class: "modal-footer d-flex justify-content-center" }

import { ref, computed } from 'vue'
import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import { ComputedRef } from 'vue-demi'
import { USER_POST_STORE } from '@/store/constants'
import { UpdateStatusMessage } from '@/services/user-post.services'
import { ChatStateTypes } from '@/store/modules/chat'
import { ERROR_STATUS_HAS_CHANGED } from '@/constants/index'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  props: {
  onCommunitySitePost: {
    type: Boolean,
    default: false,
  },
  commentPublished: {
    type: Boolean,
    default: false,
  },
},
  emits: ['showUpdateCommentErrorModal', 'afterUpdateComment', 'submitConfirm'],
  setup(__props, { expose, emit }) {

const props = __props

const loadingButton = ref(false)
const comment = computed<ComputedRef<Pick<ChatStateTypes, 'comment'>>>(() => store.getters[USER_POST_STORE.GETTERS.GET_COMMENT])
const store = useStore()



expose({
  loadingButton,
})

const commentStatusPublished = computed(() => {
  return props.onCommunitySitePost ? props.commentPublished : comment.value.published
})

const modalTitle = computed(() => (commentStatusPublished.value ? translate('privateCommentAdmin') : translate('confirmPublicComentAdmin')))

const modalContent = computed(() => (commentStatusPublished.value ? translate('makePrivateCommentAdmin') : translate('makePublicCommentAdmin')))

const confirmTextBtn = computed(() => (commentStatusPublished.value ? translate('keepPrivate') : translate('makePublic')))

const handleUpdateStatus = async () => {
  loadingButton.value = true
  if (props.onCommunitySitePost) {
    emit('submitConfirm')
    return
  }
  const payload: UpdateStatusMessage = {
    post_id: comment.value.post_id,
    comment_id: comment.value.id,
    published: !comment.value.published,
  }

  const isUpdate = await store.dispatch(USER_POST_STORE.ACTIONS.UPDATE_STATUS_COMMENT, payload)
  loadingButton.value = false
  if (!isUpdate.success && isUpdate.message_code === ERROR_STATUS_HAS_CHANGED) {
    emit('showUpdateCommentErrorModal')
    return
  }
  emit('afterUpdateComment', {
    resultUpdate: isUpdate.success,
    commentPublished: payload.published,
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(modalTitle)), 1),
          _hoisted_6
        ]),
        _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(modalContent)), 1),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(Button, {
            title: _unref(translate)('cancel'),
            type: 'secondary',
            "data-bs-dismiss": "modal",
            class: "me-2"
          }, null, 8, ["title"]),
          _createVNode(Button, {
            title: _unref(confirmTextBtn),
            type: 'secondary',
            loading: loadingButton.value,
            disabled: loadingButton.value,
            onClick: handleUpdateStatus,
            key: _unref(commentStatusPublished)
          }, null, 8, ["title", "loading", "disabled"])
        ])
      ])
    ])
  ]))
}
}

})